import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-964c28e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-layout" }
const _hoisted_2 = { class: "pay-channel-content-div" }
const _hoisted_3 = { class: "pay-channel-card" }
const _hoisted_4 = { class: "pay-channel-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "支付通道管理", -1))
const _hoisted_6 = {
  key: 0,
  class: "pay-mode-notice warning"
}
const _hoisted_7 = { class: "notice-icon" }
const _hoisted_8 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"width":"18px","height":"18px"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12 9V13M12 17H12.01M5.07 19H18.93C20.47 19 21.44 17.33 20.66 16L13.73 4C12.96 2.67 11.04 2.67 10.27 4L3.34 16C2.56 17.33 3.53 19 5.07 19Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("当前小店为"),
  /*#__PURE__*/_createElementVNode("strong", null, "自定义支付通道"),
  /*#__PURE__*/_createTextVNode("，游客访问小店后，将使用您自定义的支付通道进行支付，请确保余额充足，否则即使支付成功，余额支付开通授权时也会失败。 ")
], -1))
const _hoisted_12 = {
  key: 1,
  class: "pay-mode-notice info"
}
const _hoisted_13 = { class: "notice-icon" }
const _hoisted_14 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"width":"18px","height":"18px"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12 16C12.5523 16 13 15.5523 13 15C13 14.4477 12.5523 14 12 14C11.4477 14 11 14.4477 11 15C11 15.5523 11.4477 16 12 16ZM12 8V12M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("当前小店为"),
  /*#__PURE__*/_createElementVNode("strong", null, "系统支付通道"),
  /*#__PURE__*/_createTextVNode("，游客访问小店后，将使用系统支付通道进行支付，您自定义的支付通道不会生效，游客支付授权成功后，将发放反利给您。 ")
], -1))

import { ref, computed, onMounted } from 'vue'
import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'
import UserHead from '@/components/UserHead.vue'
import UserHeadTop from '@/components/UserHeadTop.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PayChannelView',
  setup(__props) {

const baseURL = process.env.VUE_APP_API_BASE_URL
const headers = { 'token': localStorage.getItem('token') || '' }

const channelList = ref<any[]>([])
const loading = ref(false)
const dialogVisible = ref(false)
const isEdit = ref(false)
const submitting = ref(false)
const orderPayMode = ref('')

const channelForm = ref<any>({
    id: 0,
    name: '',
    platform: 1,
    type: '',
    config: '',
    state: 1,
})

// 用于编辑/新增时的配置对象
const channelConfig = ref<Record<string, any>>({})

// 易支付时多选的支付类型
const selectedTypes = ref<string[]>([])

// platform映射：1=易支付，2=支付宝
const formatPlatform = (p: any) => {
    const map: Record<number, string> = { 1: '易支付', 2: '支付宝' }
    return map[p] || '未知'
}

// 解析type为数组（兼容数组、JSON字符串、旧格式如"['alipay']"）
const parseType = (t: any): string[] => {
    if (!t) return []
    if (Array.isArray(t)) return t
    try {
        const parsed = JSON.parse(t)
        if (Array.isArray(parsed)) return parsed
    } catch {
        // 旧格式如 "['alipay']" 不是合法JSON，尝试用正则提取
        const matches = String(t).match(/'([^']+)'/g)
        if (matches) return matches.map(m => m.replace(/'/g, ''))
    }
    return [String(t)]
}

// type映射（支持数组和字符串）
const formatType = (t: any) => {
    if (!t) return '-'
    const typeMap: Record<string, string> = { wxpay: '微信支付', alipay: '支付宝', qqpay: 'QQ支付', usdt: 'USDT' }
    const arr = parseType(t)
    if (arr.length === 0) return '-'
    return arr.map(item => typeMap[item] || item).join('、')
}

// 支付方式：根据platform和config.product_code判断
const formatPayMethod = (row: any) => {
    if (row.platform === 1) return '易支付(跳转)'
    if (row.platform === 2) {
        try {
            const config = typeof row.config === 'string' ? JSON.parse(row.config) : row.config
            if (config.product_code === 'FAST_INSTANT_TRADE_PAY') return '网站支付(跳转)'
            return '当面付(扫码)'
        } catch {
            return '当面付(扫码)'
        }
    }
    return '-'
}

// 编辑时实际使用的通道类型（仅UI使用）
const editType = ref('yipay')

// 根据row数据推断editType
const detectEditType = (row: any): string => {
    if (row.platform === 2) {
        const config = parseConfig(row.config)
        if (config.product_code === 'FAST_INSTANT_TRADE_PAY') return 'alipay_web'
        return 'alipay_dmf'
    }
    return 'yipay'
}

// 切换支付平台时清理无关配置
const onPlatformChange = (newType: string) => {
    if (newType === 'yipay') {
        // 切到易支付，保留易支付字段，清理支付宝字段
        const kept: Record<string, any> = {}
        if (channelConfig.value.url) kept.url = channelConfig.value.url
        if (channelConfig.value.pid) kept.pid = channelConfig.value.pid
        if (channelConfig.value.key) kept.key = channelConfig.value.key
        channelConfig.value = kept
        channelForm.value.platform = 1
    } else if (newType === 'alipay_dmf') {
        // 切到当面付，保留支付宝字段，设置产品码
        const kept: Record<string, any> = {}
        if (channelConfig.value.app_id) kept.app_id = channelConfig.value.app_id
        if (channelConfig.value.public_key) kept.public_key = channelConfig.value.public_key
        if (channelConfig.value.private_key) kept.private_key = channelConfig.value.private_key
        kept.product_code = 'FACE_TO_FACE_PAYMENT'
        channelConfig.value = kept
        channelForm.value.platform = 2
        selectedTypes.value = []
    } else if (newType === 'alipay_web') {
        // 切到网站支付，保留支付宝字段，设置产品码
        const kept: Record<string, any> = {}
        if (channelConfig.value.app_id) kept.app_id = channelConfig.value.app_id
        if (channelConfig.value.public_key) kept.public_key = channelConfig.value.public_key
        if (channelConfig.value.private_key) kept.private_key = channelConfig.value.private_key
        kept.product_code = 'FAST_INSTANT_TRADE_PAY'
        channelConfig.value = kept
        channelForm.value.platform = 2
        selectedTypes.value = []
    }
}

// 配置摘要
const configSummary = (configStr: any) => {
    if (!configStr) return '-'
    try {
        const obj = typeof configStr === 'string' ? JSON.parse(configStr) : configStr
        const keys = Object.keys(obj)
        if (keys.length === 0) return '-'
        return keys.map(k => `${k}=${obj[k]}`).join(', ')
    } catch {
        return String(configStr)
    }
}

// 将 config 字符串解析为编辑用的对象
const parseConfig = (configStr: any): Record<string, any> => {
    if (!configStr) return {}
    try {
        return typeof configStr === 'string' ? JSON.parse(configStr) : { ...configStr }
    } catch {
        return {}
    }
}

// 将配置对象序列化为字符串
const stringifyConfig = (obj: Record<string, any>): string => {
    return JSON.stringify(obj)
}

const getChannelList = async () => {
    loading.value = true
    try {
        const res = await axios.post(baseURL + '/api/shop/tenant/payChannels', {}, { headers })
        if (res.data.code === 0) {
            const data = res.data.data
            // 新结构：{ list, order_pay_mode }
            if (data && data.list) {
                channelList.value = data.list
                orderPayMode.value = data.order_pay_mode || ''
            } else if (Array.isArray(data)) {
                // 兼容旧结构
                channelList.value = data
                orderPayMode.value = res.data.order_pay_mode || ''
            } else {
                channelList.value = []
            }
        } else {
            ElMessage.error(res.data.msg || '获取支付通道失败')
        }
    } catch (e: any) {
        ElMessage.error('获取支付通道失败：' + e.message)
    } finally {
        loading.value = false
    }
}

const openAddDialog = () => {
    isEdit.value = false
    channelForm.value = { id: 0, name: '', platform: 1, type: [], config: '', state: 1 }
    editType.value = 'yipay'
    channelConfig.value = {}
    selectedTypes.value = []
    dialogVisible.value = true
}

const openEditDialog = (row: any) => {
    isEdit.value = true
    channelForm.value = { ...row }
    channelConfig.value = parseConfig(row.config)
    editType.value = detectEditType(row)
    // 易支付时初始化多选支付类型
    if (editType.value === 'yipay') {
        selectedTypes.value = parseType(row.type)
    } else {
        selectedTypes.value = []
    }
    dialogVisible.value = true
}

const submitChannel = async () => {
    // 同步platform和type
    if (editType.value === 'yipay') {
        channelForm.value.platform = 1
        if (selectedTypes.value.length === 0) {
            ElMessage.warning('请选择支付类型')
            return
        }
        channelForm.value.type = selectedTypes.value
    } else if (editType.value === 'alipay_dmf') {
        channelForm.value.platform = 2
        channelForm.value.type = ['alipay']
        channelConfig.value.product_code = 'FACE_TO_FACE_PAYMENT'
    } else if (editType.value === 'alipay_web') {
        channelForm.value.platform = 2
        channelForm.value.type = ['alipay']
        channelConfig.value.product_code = 'FAST_INSTANT_TRADE_PAY'
    }
    // 校验配置必填项
    const configValues = Object.values(channelConfig.value).filter(v => v !== undefined && v !== '')
    if (configValues.length === 0) {
        ElMessage.warning('请填写通道配置信息')
        return
    }
    submitting.value = true
    try {
        const url = isEdit.value ? '/api/shop/tenant/payChannel/update' : '/api/shop/tenant/payChannel/add'
        const payload = {
            ...channelForm.value,
            type: JSON.stringify(channelForm.value.type),
            config: stringifyConfig(channelConfig.value),
        }
        const res = await axios.post(baseURL + url, payload, { headers })
        if (res.data.code === 0) {
            ElMessage.success(isEdit.value ? '修改成功' : '添加成功')
            dialogVisible.value = false
            getChannelList()
        } else {
            ElMessage.error(res.data.msg || '操作失败')
        }
    } catch (e: any) {
        ElMessage.error('操作失败：' + e.message)
    } finally {
        submitting.value = false
    }
}

const deleteChannel = (row: any) => {
    ElMessageBox.confirm(`确认删除支付通道「${row.name || formatPlatform(row.platform)}」吗？`, '提示', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning',
    }).then(async () => {
        try {
            const res = await axios.post(baseURL + '/api/shop/tenant/payChannel/delete', { id: row.id }, { headers })
            if (res.data.code === 0) {
                ElMessage.success('删除成功')
                getChannelList()
            } else {
                ElMessage.error(res.data.msg || '删除失败')
            }
        } catch (e: any) {
            ElMessage.error('删除失败：' + e.message)
        }
    }).catch(() => { /* 取消 */ })
}

onMounted(() => {
    getChannelList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, { style: {"width":"fit-content"} }, {
          default: _withCtx(() => [
            _createVNode(UserHead)
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, { style: {"padding":"0"} }, {
              default: _withCtx(() => [
                _createVNode(UserHeadTop)
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, { style: {"padding-top":"0","height":"100vh","overflow":"auto","padding-left":"0","background-color":"rgb(242, 242, 242) !important"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: openAddDialog
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("新增通道")
                        ]),
                        _: 1
                      })
                    ]),
                    (orderPayMode.value === 'tenant')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10))
                          ]),
                          _hoisted_11
                        ]))
                      : (orderPayMode.value === 'system')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_16))
                            ]),
                            _hoisted_17
                          ]))
                        : _createCommentVNode("", true),
                    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                      data: channelList.value,
                      class: "pay-channel-table"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "name",
                          label: "通道名称"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("span", null, _toDisplayString(scope.row.name || formatPlatform(scope.row.platform)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "platform",
                          label: "支付平台",
                          width: "100"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_tag, { size: "small" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(formatPlatform(scope.row.platform)), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "type",
                          label: "支付类型",
                          width: "100"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_tag, {
                              size: "small",
                              type: "info"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(formatType(scope.row.type)), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "支付方式",
                          width: "120"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("span", null, _toDisplayString(formatPayMethod(scope.row)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "配置信息",
                          "show-overflow-tooltip": ""
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("span", null, _toDisplayString(configSummary(scope.row.config)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "state",
                          label: "状态",
                          width: "80"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_tag, {
                              type: scope.row.state === 1 ? 'success' : 'info',
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.state === 1 ? '启用' : '禁用'), 1)
                              ]),
                              _: 2
                            }, 1032, ["type"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "操作",
                          width: "150",
                          fixed: "right"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_button, {
                              size: "small",
                              onClick: ($event: any) => (openEditDialog(scope.row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("编辑")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_el_button, {
                              size: "small",
                              type: "danger",
                              onClick: ($event: any) => (deleteChannel(scope.row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("删除")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])), [
                      [_directive_loading, loading.value]
                    ])
                  ])
                ]),
                _createVNode(_component_el_dialog, {
                  modelValue: dialogVisible.value,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((dialogVisible).value = $event)),
                  title: isEdit.value ? '编辑支付通道' : '新增支付通道',
                  width: "560px"
                }, {
                  footer: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (dialogVisible.value = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("取消")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: submitChannel,
                      loading: submitting.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("确认")
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, {
                      model: channelForm.value,
                      "label-width": "100px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "通道名称" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: channelForm.value.name,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((channelForm.value.name) = $event)),
                              placeholder: "如：支付宝通道（留空则显示平台名）"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "支付平台",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: editType.value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editType).value = $event)),
                              placeholder: "选择支付平台",
                              style: {"width":"100%"},
                              onChange: onPlatformChange
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: "yipay",
                                  label: "易支付"
                                }),
                                _createVNode(_component_el_option, {
                                  value: "alipay_dmf",
                                  label: "支付宝当面付"
                                }),
                                _createVNode(_component_el_option, {
                                  value: "alipay_web",
                                  label: "支付宝网站支付"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        (editType.value === 'yipay')
                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 0,
                              label: "支付类型",
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: selectedTypes.value,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedTypes).value = $event)),
                                  multiple: "",
                                  placeholder: "选择支持的支付类型（可多选）",
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      value: "wxpay",
                                      label: "微信支付"
                                    }),
                                    _createVNode(_component_el_option, {
                                      value: "alipay",
                                      label: "支付宝"
                                    }),
                                    _createVNode(_component_el_option, {
                                      value: "qqpay",
                                      label: "QQ支付"
                                    }),
                                    _createVNode(_component_el_option, {
                                      value: "usdt",
                                      label: "USDT"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (editType.value === 'yipay')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createVNode(_component_el_form_item, {
                                label: "接口URL",
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: channelConfig.value.url,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((channelConfig.value.url) = $event)),
                                    placeholder: "https://pay.example.com"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "商户PID",
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: channelConfig.value.pid,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((channelConfig.value.pid) = $event)),
                                    placeholder: "易支付商户ID"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "商户KEY",
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: channelConfig.value.key,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((channelConfig.value.key) = $event)),
                                    placeholder: "易支付商户密钥",
                                    "show-password": ""
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ], 64))
                          : (editType.value === 'alipay_dmf')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createVNode(_component_el_form_item, {
                                  label: "AppID",
                                  required: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: channelConfig.value.app_id,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((channelConfig.value.app_id) = $event)),
                                      placeholder: "支付宝应用ID"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "公钥",
                                  required: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: channelConfig.value.public_key,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((channelConfig.value.public_key) = $event)),
                                      type: "textarea",
                                      rows: 3,
                                      placeholder: "支付宝公钥"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "私钥",
                                  required: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: channelConfig.value.private_key,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((channelConfig.value.private_key) = $event)),
                                      type: "textarea",
                                      rows: 3,
                                      placeholder: "应用私钥"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ], 64))
                            : (editType.value === 'alipay_web')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  _createVNode(_component_el_form_item, {
                                    label: "AppID",
                                    required: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: channelConfig.value.app_id,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((channelConfig.value.app_id) = $event)),
                                        placeholder: "支付宝应用ID"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, {
                                    label: "公钥",
                                    required: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: channelConfig.value.public_key,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((channelConfig.value.public_key) = $event)),
                                        type: "textarea",
                                        rows: 3,
                                        placeholder: "支付宝公钥"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, {
                                    label: "私钥",
                                    required: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: channelConfig.value.private_key,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((channelConfig.value.private_key) = $event)),
                                        type: "textarea",
                                        rows: 3,
                                        placeholder: "应用私钥"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ], 64))
                              : _createCommentVNode("", true),
                        _createVNode(_component_el_form_item, { label: "状态" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_switch, {
                              modelValue: channelForm.value.state,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((channelForm.value.state) = $event)),
                              "active-value": 1,
                              "inactive-value": 2,
                              "active-text": "启用",
                              "inactive-text": "禁用"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "title"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})